import React from "react";

const SvgComponent = props => (
  <svg width={51.256} height={33.85} viewBox="0 0 51.256 33.85" {...props}>
    <path
      d="M35.942 33.849a7.607 7.607 0 007.607-7.607s.004-.979-.357-2.234c2.798-.528 5.291-2.021 7.113-4.125 2.369-2.72-.332-2.661-1.25-2.806-5.425-.667-12.755-6.32-10.06-15.266.584-1.921-.529-1.941-1.34-1.708 0 0-8.463 1.877-8.992 11.607-1.422-.294-2.676-.225-3.332-.048-2.027-2.017-5.4-3.498-8.811-3.498-6.766 0-12.309 5.23-12.807 11.867A7.394 7.394 0 000 26.447a7.399 7.399 0 007.4 7.402h28.542zM8.041 31.015c-2.766 0-4.805-2-4.805-4.589 0-2.114 1.344-3.969 3.441-4.602.25-9.993 9.027-10.503 10.002-10.503 2.9 0 5.777 1.422 7.629 3.527 3.742-1.229 8.871 1.656 8.298 7.235 1.461-.592 2.922-.545 3.34-.545 2.099 0 4.63 1.834 4.63 4.846a4.629 4.629 0 01-4.63 4.63H8.041zm33.787-9.726c-1.146-1.447-3.06-2.647-6.236-2.647-.723-2.975-2.305-4.769-4.038-5.813-.437-5.017 2.688-7.91 4.241-8.861-1.244 6.447 3.924 14.429 11.147 15.188-1.386 1.055-3.229 1.894-5.114 2.133z"
      fill="#83a5b3"
    />
  </svg>
);

export default __webpack_public_path__ + "static/media/02n.01549e46.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/02n.svg